import React from 'react'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  Tooltip,
  Legend,
)

const GraficoSaidaPorMes = ({ indicador }) => {
  const data = {
    labels: indicador.saidas6meses.labels,
    datasets: [
      {
        label: 'Saídas últimos 6 meses',
        data: indicador.saidas6meses.total,
        backgroundColor: '#eb5858',
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        type: 'logarithmic', // 👈 agora funciona
      },
    },
  }

  return (
    <div style={{ width: '100%', height: '180px' }}>
      <Bar
        key={JSON.stringify(indicador.entradas6meses.total)}
        data={data}
        options={options}
        redraw
      />
    </div>
  )
}

export default GraficoSaidaPorMes
